import type { Percorso } from '@aulaviva/shared';
import { Alert, Button, DataTable, EmptyState, type ColumnDef } from '@aulaviva/ui';
import { FolderOpen, Plus } from 'lucide-react';
import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router';
import { usePercorsiAdmin } from '@/api/admin';
import { admin, comuni } from '@/testi';
import { BadgePercorso, IntestazioneAdmin } from './comuni';

export function Percorsi() {
  const t = admin.percorsi;
  const navigate = useNavigate();
  const percorsi = usePercorsiAdmin();

  const colonne = useMemo<ColumnDef<Percorso, unknown>[]>(
    () => [
      { header: t.colonne.titolo, cell: ({ row }) => <Link to={`/admin/percorsi/${row.original.id}`}>{row.original.titolo}</Link> },
      { header: t.colonne.anno, accessorKey: 'anno' },
      { header: t.colonne.stato, cell: ({ row }) => <BadgePercorso stato={row.original.stato} /> },
      { header: t.colonne.iscritti, accessorKey: 'numeroIscritti' },
      { header: t.colonne.webinar, accessorKey: 'numeroWebinar' },
    ],
    [t],
  );

  return (
    <>
      <IntestazioneAdmin
        titolo={t.titolo}
        sottotitolo={t.sottotitolo}
        azione={
          <Button variant="primary" icon={Plus} onClick={() => navigate('/admin/percorsi/nuovo')}>
            {t.nuovo}
          </Button>
        }
      />
      {percorsi.isError && <Alert variant="error" title={percorsi.error.message} action={<Button onClick={() => percorsi.refetch()}>{comuni.riprova}</Button>} />}
      <DataTable
        caption={t.titolo}
        columns={colonne}
        data={percorsi.data ?? []}
        getRowId={(p) => p.id}
        loading={percorsi.isPending}
        testi={admin.comuni}
        empty={
          <EmptyState icon={FolderOpen} title={t.nessunoTitolo}>
            {t.nessunoTesto}
          </EmptyState>
        }
      />
    </>
  );
}
